module.exports = __webpack_public_path__ + "img/optional-step-1.daf986f2.png";